// ── FAQ accordion ──
(function() {
  document.querySelectorAll('.faq-q').forEach(function(btn) {
    if (btn.dataset.faqBound) return;
    btn.dataset.faqBound = '1';
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });
})();

// ── Hero typewriter ──
(function() {
  var phrases = ['Built for women.', 'Morning ready.', 'Easy to mix.', 'Loved by Women.'];
  var el = document.getElementById('heroTyped');
  if (!el) return;
  var i = 0, j = 0, deleting = false, hold = 0;
  function tick() {
    if (hold > 0) { hold--; setTimeout(tick, 100); return; }
    var phrase = phrases[i % phrases.length];
    if (!deleting) {
      j++;
      el.textContent = phrase.slice(0, j);
      if (j === phrase.length) { deleting = true; hold = 18; }
      setTimeout(tick, 85);
    } else {
      j--;
      el.textContent = phrase.slice(0, j);
      if (j === 0) { deleting = false; i++; hold = 4; }
      setTimeout(tick, 45);
    }
  }
  tick();
})();

// ── Smooth scroll to section ──
function smoothScrollToSection(id) {
  var t = document.getElementById(id);
  if (!t) return;
  var s = window.scrollY, end = t.getBoundingClientRect().top + s, d = 900, ts = performance.now();
  function step(n) {
    var p = Math.min(1, (n - ts) / d);
    var q = p * p * (3 - 2 * p);
    window.scrollTo(0, s + (end - s) * q);
    if (p !== 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// ── Nutrition modal close on backdrop click ──
(function() {
  var modal = document.getElementById('nutritionModal');
  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) modal.style.display = 'none';
    });
  }
})();
